import React from 'react';
import { getUniqueKey } from "../../utils/KeyUtils";
import { ModalsActionsChangeProps, ModalsActionsClose, ModalsActionsOpen, MODAL_ACTIONS_CHANGE_PROPS, MODAL_ACTIONS_CLOSE, MODAL_ACTIONS_OPEN } from './ModalsActionTypes';
import { IModalProps } from "./ModalsReducer";

export const modalsActionsOpen = (component: React.ElementType, componentProps: IModalProps, key?: string): ModalsActionsOpen => {
  return {
    type: MODAL_ACTIONS_OPEN,
    payload: {
      component: component,
      componentProps,
      key: key || getUniqueKey(),
      opened: true,
    }
  }
};

export const modalsActionsChangeProps = (key: string, componentProps: IModalProps): ModalsActionsChangeProps => {
  return {
    type: MODAL_ACTIONS_CHANGE_PROPS,
    payload: {
      componentProps,
      key
    }
  }
};

export const modalsActionsClose = (key: string): ModalsActionsClose => {
  return {
    type: MODAL_ACTIONS_CLOSE,
    payload: {
      key
    }
  }
};